import type { Collection } from '../types';

interface CollectionSelectorProps {
  collections: Collection[];
  selectedId: string;
  onChange: (id: string) => void;
  isLoading: boolean;
  error: string | null;
}

export function CollectionSelector({
  collections,
  selectedId,
  onChange,
  isLoading,
  error,
}: CollectionSelectorProps) {
  if (error) {
    return (
      <div className="card error">
        <h2 className="card-title">
          <span className="step-number">1</span>
          Select Collection
        </h2>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 className="card-title">
        <span className="step-number">1</span>
        Select Collection
      </h2>
      {isLoading ? (
        <div className="loading">
          <div className="spinner" />
          <span>Loading collections...</span>
        </div>
      ) : (
        <select
          className="select"
          value={selectedId}
          onChange={(e) => onChange(e.target.value)}
          disabled={collections.length === 0}
        >
          <option value="">
            {collections.length === 0
              ? 'No collections available'
              : 'Select a collection...'}
          </option>
          {collections.map((collection) => (
            <option key={collection.id} value={collection.id}>
              {collection.name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
